import { render } from "./ActivityDetailOverlay.vue?vue&type=template&id=3594562e&scoped=true"
import script from "./ActivityDetailOverlay.vue?vue&type=script&lang=js"
export * from "./ActivityDetailOverlay.vue?vue&type=script&lang=js"

import "./ActivityDetailOverlay.vue?vue&type=style&index=0&id=3594562e&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3594562e"]])

export default __exports__